module.exports = __webpack_public_path__ + "static/media/Home_Products_07.fd1f2c91.png";